module.exports = __webpack_public_path__ + "img/maintenance.de866ceb.jpg";